import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { SsrModule } from 'app/constants/ssrModules';
import { Spinner } from 'app/design-system/components/Spinner';

import { RootMenu } from '../../components/RootMenu';
import { loading, requested, rootMenuItemsWithPathname } from '../../selectors/prematch';
import { PrematchMenuLoader } from './Loader';

export const PrematchMenu = () => {
  const { pathname } = useLocation();
  const requestedS = useSelector(requested);
  const loadingS = useSelector(loading);
  const realLoading = !requestedS || loadingS;
  const items = useSelector(rootMenuItemsWithPathname(pathname));

  return (
    <>
      <PrematchMenuLoader />

      {realLoading
        ? <Spinner size={40} />
        : (
          <RootMenu ssrDataId={SsrModule.LEFT_MENU_PREMATCH}
                    list={items} />
        )
      }
    </>
  );
};
